import { ENTITLEMENTS, type DimensionScore, type Grade } from '@astrally/shared';

/**
 * Score → grade conversion. Grades label a dimension of a pair — never a
 * person. Thresholds live in the shared entitlement/config layer.
 */
export function gradeFromScore(score: number): Grade {
  const t = ENTITLEMENTS.gradeThresholds;
  if (score >= t.A) return 'A';
  if (score >= t.B) return 'B';
  if (score >= t.C) return 'C';
  return 'D';
}

export function toDimensionScore(score: number): DimensionScore {
  const clamped = Math.min(1, Math.max(0, score));
  return { score: Number(clamped.toFixed(3)), grade: gradeFromScore(clamped) };
}
